import { Link } from 'react-router-dom';

import { ListItemButton, ListItemText } from '@mui/material';
import Typography from '@mui/material/Typography';

type Section = {
	title: string;
	link: string;
	disabled?: boolean;
};

const sections: Section[] = [
	{ title: 'Published Events', link: 'integration-events' },
	{ title: 'Read Models', link: 'read-models', disabled: true },
];

interface ContextLinksProps {
	contextId: string;
	selectedSection?: string;
}

const ContextLinks: React.FC<ContextLinksProps> = ({ contextId, selectedSection }) => {
	return (
		<>
			{sections.map((section) => {
				const isSelected = section.title === selectedSection;

				return (
					<ListItemButton key={section.title} component={Link} to={`/${section.link}/${contextId}`} sx={{ pl: 3 }} disabled={section.disabled}>
						<ListItemText
							primary={
								<Typography
									variant="body2"
									sx={{
										fontWeight: isSelected ? 700 : 400,
										color: 'text.primary',
									}}
								>
									{section.title}
								</Typography>
							}
						/>
					</ListItemButton>
				);
			})}
		</>
	);
};

export default ContextLinks;
